import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap"
import { FaLinkedin, FaInstagram, FaFacebook } from "react-icons/fa"
import { MdWork } from "react-icons/md"
import NaukariIcon from "./../../assets/images/Naukari_Icon.jpg"
import SunEditor from "suneditor-react"
import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer"
import PreviewScreenshot from "./../../assets/images/PreviewScreenshot.png"
import axios from "axios"
import Swal from "sweetalert2"
const platformIcons = {
  linkedin: <FaLinkedin />,
  instagram: <FaInstagram />,
  facebook: <FaFacebook />,
  naukri: <MdWork />,
}
const platformColors = {
  linkedin: "#0A66C2",
  instagram: "#E1306C",
  facebook: "#1877F2",
  naukri: "#2E3A59",
}
const aiPreviews = {
  linkedin: `
    <p><strong>🚀 We’re Hiring | React Developer</strong></p>
    <p>
      We are looking for a passionate <strong>React Developer</strong> to join our
      growing engineering team and work on scalable web applications.
    </p>
    <p><strong>📍 Location:</strong> Hyderabad<br/>
       <strong>💼 Experience:</strong> 2–5 Years<br/>
       <strong>🕘 Shift:</strong> Day Shift
    </p>
    <p><strong>🔹 Roles & Responsibilities:</strong></p>
    <ul>
      <li>Develop and maintain user-facing features using React.js</li>
      <li>Collaborate with backend teams for API integration</li>
      <li>Optimize components for performance and scalability</li>
      <li>Write clean, reusable, and maintainable code</li>
    </ul>
    <p><strong>🔹 Required Skills:</strong></p>
    <ul>
      <li>Strong knowledge of React.js and JavaScript (ES6+)</li>
      <li>Experience with REST APIs</li>
      <li>HTML, CSS, Bootstrap</li>
      <li>Git / Version Control</li>
    </ul>
    <p><strong>🎓 Education:</strong> Bachelor’s degree in Computer Science or related field</p>
    <p>👉 Interested candidates can apply or share this opportunity with their network.</p>
    <p>#Hiring #ReactDeveloper #FrontendDeveloper #Careers #Jobs</p>
  `,
  instagram: `
    <p><strong>🚀 We’re Hiring React Developers!</strong></p>
    <p>💻 React.js Developer<br/>📍 Hyderabad<br/>⏳ 2–5 Years Experience</p>
    <p><strong>What you’ll do 👇</strong></p>
    <ul>
      <li>Build modern UI using React</li>
      <li>Work with APIs & frontend logic</li>
      <li>Improve performance & UX</li>
    </ul>
    <p><strong>Skills Needed 🛠</strong></p>
    <ul>
      <li>React.js, JavaScript</li>
      <li>HTML, CSS</li>
      <li>API Integration</li>
    </ul>
    <p><strong>Education 🎓</strong><br/>Any graduate in IT / CS</p>
    <p>📩 Apply now or tag someone who might be interested!</p>
    <p>#Hiring #ReactJS #FrontendDeveloper #Jobs</p>
  `,
  facebook: `
    <p><strong>📢 Job Opportunity – React Developer</strong></p>
    <p>We are hiring a React Developer for our Hyderabad office.</p>
    <p><strong>Experience:</strong> 2–5 Years</p>
    <p><strong>Roles & Responsibilities:</strong></p>
    <ul>
      <li>Design and develop React-based UI components</li>
      <li>Integrate frontend with backend services</li>
      <li>Debug and improve existing applications</li>
    </ul>
    <p><strong>Required Skills:</strong></p>
    <ul>
      <li>React.js & JavaScript</li>
      <li>REST APIs</li>
      <li>HTML, CSS, Bootstrap</li>
    </ul>
    <p><strong>Education:</strong> Graduate / Postgraduate in Computer Science</p>
    <p>Interested candidates can comment or message us for more details.</p>
  `,
  naukri: `
    <p><strong>Job Title:</strong> React Developer</strong></p>
    <p>
      <strong>Location:</strong> Hyderabad<br/>
      <strong>Experience:</strong> 2–5 Years<br/>
      <strong>Employment Type:</strong> Full-Time
    </p>
    <p><strong>Job Description:</strong></p>
    <ul>
      <li>Develop and maintain scalable React applications</li>
      <li>Implement reusable UI components</li>
      <li>Collaborate with cross-functional teams</li>
      <li>Ensure code quality and performance optimization</li>
    </ul>
    <p><strong>Key Skills:</strong></p>
    <ul>
      <li>React.js</li>
      <li>JavaScript (ES6+)</li>
      <li>HTML, CSS</li>
      <li>REST API Integration</li>
    </ul>
    <p><strong>Education Qualification:</strong></p>
    <ul>
      <li>B.E / B.Tech / MCA / B.Sc (IT/CS)</li>
    </ul>
  `,
}
const SocialMediaPost2 = ({
  jobData,
  postToLinkedIn,
  setPostToLinkedIn,
  setJobData,
  selectedLinkedInOrg,
  setSelectedLinkedInOrg,
  setSelectedTemplateContent,
  getsingleJobOrderid,
  setSelectedPreviewId,
  selectedPreviewId
  // fetchLinkedInOrgs,
  // linkedInOrgs = [],
}) => {
  const navigate = useNavigate()
  const [platforms, setPlatforms] = useState({
    linkedin: jobData?.post_to_linkedin ? "yes" : "no",
    instagram: null,
    facebook: null,
    naukri: null,
  })
const handleSelectPreview = (key, previewObj) => {
  setSelectedTemplate(key)                 // preview_1
  setSelectedTemplateContent(previewObj.html) // HTML
  setSelectedPreviewId(previewObj.id)      // ✅ preview_id → parent
}
const isThisTemplatePosted =
  Boolean(jobData?.post_to_linkedin) &&
  Number(jobData?.linkedin_template) === Number(selectedPreviewId);
console.log("isThisTemplatePosted",isThisTemplatePosted)
useEffect(()=>{
  console.log("isThisTemplatePosted",isThisTemplatePosted)
},[])
  const userInfos = JSON.parse(sessionStorage.getItem("atsuser-info"))
  const intialcompanyId = userInfos.user_details.companies_data[0].company_id
  const [linkedinPreview, setLinkedinPreview] = useState({})
  // const [selectedTemplateContent, setSelectedTemplateContent] = useState("")

  const [loadingPreview, setLoadingPreview] = useState(false)
  const templateKeys = Object.keys(linkedinPreview || {})
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedTemplate, setSelectedTemplate] = useState(null)
  const [isEditing, setIsEditing] = useState(false)
  const [editedText, setEditedText] = useState("")
  const isPosted = Boolean(jobData?.post_to_linkedin);
  const [isRemoving, setIsRemoving] = useState(false);
  const [removeError, setRemoveError] = useState("");

  const handleEditOpen = () => {
    const key = templateKeys[activeIndex]
    setEditedText(linkedinPreview[key]?.html || "")

    setIsEditing(true)
  }
  const stripHtml = html => {
  const temp = document.createElement("div")
  temp.innerHTML = html
  return temp.textContent || temp.innerText || ""
}
// useEffect(() => {
//   setPlatforms((prev) => ({
//     ...prev,
//     linkedin: jobData?.post_to_linkedin ? "yes" : "no",
//   }));
//   setPostToLinkedIn(!!jobData?.post_to_linkedin);
// }, [jobData]);
// useEffect(() => {
//   if (jobData?.post_to_linkedin !== undefined) {
//     setPostToLinkedIn(!!jobData.post_to_linkedin);
//   }
// }, [jobData]);
useEffect(() => {
  if (jobData?.post_to_linkedin !== undefined) {
    setPostToLinkedIn(!!jobData.post_to_linkedin);
  }
}, [jobData?.post_to_linkedin]);


const saveContentPreview = async (content) => {
  try {
    const response = await axios.post(
      "/api/v1/content-preview/",
      {
        content: content,
        preview_id: selectedPreviewId
      },
    );

    return response.data;
  } catch (error) {
    console.error("Error saving content preview", error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to save content preview",
    });
    throw error;
  }
};

  const handleEditCancel = () => {
    setIsEditing(false)
    setEditedText("")
  }
const handleEditSave = async () => {
  try {
    const key = templateKeys[activeIndex];

    // 🔥 Call API
    const data = await saveContentPreview(editedText);

    // ✅ Backend-processed HTML
    const savedHtml = data?.html_preview;

    if (!savedHtml) {
      throw new Error("No html_preview returned from API");
    }

    // ✅ Update preview list
    setLinkedinPreview(prev => ({
      ...prev,
      [key]: {
        ...prev[key],
        html: savedHtml,
      },
    }));

    // ✅ Update selected preview (parent state)
    setSelectedTemplateContent(savedHtml);

    // ✅ Update editor state
    setEditedText(savedHtml);

    setIsEditing(false);

    Swal.fire({
      icon: "success",
      title: "Saved",
      text: "Content saved successfully",
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (error) {
    console.error(error);
  }
};


useEffect(() => {
  if (jobData?.job_id && platforms.linkedin === "yes") {
    fetchLinkedInJobText();
  }
}, [jobData?.job_id, platforms.linkedin]);

  // useEffect(() => {
  //   const keys = Object.keys(linkedinPreview || {})
  //   if (keys.length > 0) {
  //     setActiveIndex(0)
  //     setSelectedTemplate(keys[0])
  //   }
  // }, [linkedinPreview])
  useEffect(() => {
  const keys = Object.keys(linkedinPreview || {})
  if (keys.length > 0 && selectedTemplate === null) {
    setActiveIndex(0)
    setSelectedTemplate(keys[0])
  }
}, [linkedinPreview, selectedTemplate])

 const fetchLinkedInJobText = async () => {
  try {
    setLoadingPreview(true)

    const res = await axios.get(
      `/api/v1/job-texts/?job_id=${jobData?.job_id}`
    )

    const previews = res?.data?.previews || {}

    // 🔥 KEEP ONLY HTML
    const htmlPreviews = Object.fromEntries(
      Object.entries(previews).map(([key, value]) => [
        key,
        {
          id: value.id,
          html: value.html,
        },
      ])
    )

    setLinkedinPreview(htmlPreviews)
  } catch (error) {
    console.error("Failed to fetch LinkedIn preview", error)
    setLinkedinPreview({})
  } finally {
    setLoadingPreview(false)
  }
}

  const [companyId, setCompanyId] = useState(intialcompanyId)
  const [editablePreviews, setEditablePreviews] = useState(aiPreviews)
  const [editMode, setEditMode] = useState({})
  const [isPosting, setIsPosting] = useState(false)
  const [successModal, setSuccessModal] = useState(false)
  const [showLinkedInModal, setShowLinkedInModal] = useState(false)
  const [linkedInOrgs, setLinkedInOrgs] = useState([])
  const [showLinkedInPreview, setShowLinkedInPreview] = useState(false)
  // useEffect(() => {
  //   console.log("postToLinkedIn ", postToLinkedIn)
  //   setPlatforms(prev => ({
  //     ...prev,
  //     linkedin: postToLinkedIn ? "yes" : "no",
  //   }))
  // }, [postToLinkedIn])
  const fetchLinkedInOrgs = async () => {
    try {
      const response = await axios.get(
        `/api/v1/linkedin-details/?company_id=${companyId}`
      )
      console.log("response.data.results", response.data.results)
      setLinkedInOrgs(response.data.results || [])
    } catch (error) {
      console.error("Error fetching LinkedIn organizations:", error)
    }
  }
  console.log("linkedInOrgs", linkedInOrgs)
  const handleRadioChange = async value => {
    setPlatforms(prev => ({ ...prev, linkedin: value }))
    if (value === "yes") {
      setPostToLinkedIn(true)
      // ✅ CALL API ONLY WHEN YES
      await fetchLinkedInJobText()
    } else {
      setPostToLinkedIn(false)
      setLinkedinPreview("") // clear preview
    }
  }
  const isAlreadyPosted = !!jobData?.post_to_linkedin
  console.log(isAlreadyPosted)
console.log("postToLinkedIn:", postToLinkedIn, "jobData.post_to_linkedin:", jobData?.post_to_linkedin);

  // const handleRemoveLinkedInPost = async () => {
  //     try {
  //         const postId = jobData.linkedin_post_id;
  //         if (!postId) {
  //             console.error("No LinkedIn post ID found.");
  //             return;
  //         }
  //         const response = await axios.post(
  //             `https://omnichannelapi.vitelglobal.com/linkedin/delete/${postId}/`,
  //             {
  //                     api_key: "c6a8a4fe-cf44-4089-a5db-9dabd700b2a0",
  //             }
  //         );
  //         if (response.status === 200) {
  //             setJobData(prev => ({ ...prev, post_to_linkedin: false, linkedin_post_id: null }));
  //             await getsingleJobOrderid(jobData.job_id);
  //             setPostToLinkedIn(false);
  //             setSuccessModal(true);
  //             Swal.fire({
  //               title: "Success!",
  //               text: "The LinkedIn post has been removed successfully.",
  //               icon: "success",
  //               confirmButtonText: "OK",
  //             });
  //         } else {
  //             console.error("Failed to remove LinkedIn post.");
  //             Swal.fire({
  //               title: "Error!",
  //               text: "Failed to remove the LinkedIn post.",
  //               icon: "error",
  //               confirmButtonText: "OK",
  //             });
  //           }
  //         } catch (error) {
  //           console.error("Error removing LinkedIn post:", error);
  //           Swal.fire({
  //             title: "Error!",
  //             text: "An error occurred while removing the LinkedIn post.",
  //             icon: "error",
  //             confirmButtonText: "OK",
  //           });
  //         }
  //       };
  const handleRemoveLinkedInPost = async () => {
    try {
       setIsRemoving(true);
    setRemoveError("");
      const jobId = jobData.job_id
      if (!jobId) {
        console.error("No job ID found.")
        return
      }
      const response = await axios.delete(
        `/api/v1/delete-linkedin-post/?job_id=${jobId}`
      )
      if (response.status === 200) {
        setJobData(prev => ({
          ...prev,
          post_to_linkedin: false,
          linkedin_post_id: null,
        }))
        await getsingleJobOrderid(jobId)
        setPostToLinkedIn(false)
        Swal.fire({
          title: "Success!",
          text: "The LinkedIn post has been removed successfully.",
          icon: "success",
          confirmButtonText: "OK",
        })
      } else {
        console.error("Failed to remove LinkedIn post.")
        Swal.fire({
          title: "Error!",
          text: "Failed to remove the LinkedIn post.",
          icon: "error",
          confirmButtonText: "OK",
        })
      }
    } catch (error) {
        console.error("Error removing LinkedIn post:", error);

        const errorMessage =
          error?.response?.data?.message ||
          "Failed to delete LinkedIn post";

        Swal.fire({
          title: "Error!",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });

    }
    finally {
    setIsRemoving(false); 
  }
  }
  const handleLinkedInOrgSelect = org => {
    console.log("Selected Organization:", org)
    setSelectedLinkedInOrg(org)
    setShowLinkedInModal(false)
  }
  const templateEntries = Object.entries(linkedinPreview || {})
  const totalTemplates = templateEntries.length
  const handlePrev = () => {
    setActiveIndex(prev => (prev === 0 ? totalTemplates - 1 : prev - 1))
    setIsEditing(false)
  }
  const handleNext = () => {
    setActiveIndex(prev => (prev === totalTemplates - 1 ? 0 : prev + 1))
    setIsEditing(false)
  }
useEffect(() => {
  if (templateEntries.length > 0) {
    const [key, previewObj] = templateEntries[activeIndex]
    handleSelectPreview(key, previewObj)
  }
}, [activeIndex, linkedinPreview])


  return (
    <React.Fragment>
      <div className="page-content1 allact-tabs1">
        <Container fluid={true}>
          <div className="page-title-box actjobbread mb-0 pb-3">
            <Row className="mt-2">
              <Col xxl={4} className="">
                <h3 className="text-center">Social Media Job Posting</h3>
                <div className="JobProtralCards">
                  <div className="card mb-3 shadow  border-0">
                    <div className="card-body">
                      <Row className="align-items-center">
                        <Col sm={2}>
                          <FaLinkedin
                            style={{
                              color: "rgb(10, 102, 194)",
                              fontSize: "3rem",
                            }}
                          />
                        </Col>
                        <Col sm={9}>
                          <div className="mb-2 fw-bold">
                            Do you want to post your job on LinkedIn?
                          </div>
                          <div className="d-flex gap-1 justify-content-start flex-column">
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="linkedin"
                                checked={platforms.linkedin === "yes"}
                                onChange={() => handleRadioChange("yes")}
                              />
                              <label className="form-check-label ms-1">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="linkedin"
                                checked={platforms.linkedin === "no"}
                                onChange={() => handleRadioChange("no")}
                                // disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                No
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {/* {renderLinkedInOrgSelection()} */}
                  <div className="card mb-3 shadow  border-0">
                    <div className="card-body">
                      <Row className="align-items-center">
                        <Col sm={2}>
                          <FaInstagram
                            style={{
                              color: "rgb(225, 48, 108)",
                              fontSize: "3rem",
                            }}
                          />
                        </Col>
                        <Col sm={9}>
                          <div className="mb-2 fw-bold">
                            Do you want to post your job on Instagram?
                          </div>
                          <div className="d-flex gap-1 justify-content-start flex-column">
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="instagram"
                                checked={platforms.instagram === "yes"}
                                onChange={() =>
                                  handleRadioChange("instagram", "yes")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="instagram"
                                checked={platforms.instagram === "no"}
                                onChange={() =>
                                  handleRadioChange("instagram", "no")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                No
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="card mb-3 shadow  border-0">
                    <div className="card-body">
                      <Row className="align-items-center">
                        <Col sm={2}>
                          <FaFacebook
                            style={{
                              color: "rgb(24, 119, 242)",
                              fontSize: "3rem",
                            }}
                          />
                        </Col>
                        <Col sm={9}>
                          <div className="mb-2 fw-bold">
                            Do you want to post your job on Facebook?
                          </div>
                          <div className="d-flex gap-1 justify-content-start flex-column">
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="facebook"
                                checked={platforms.facebook === "yes"}
                                onChange={() =>
                                  handleRadioChange("facebook", "yes")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="facebook"
                                checked={platforms.facebook === "no"}
                                onChange={() =>
                                  handleRadioChange("facebook", "no")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                No
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                  <div className="card mb-3 shadow  border-0">
                    <div className="card-body">
                      <Row className="align-items-center">
                        <Col sm={2}>
                          <img src={NaukariIcon} alt="NaukariIcon" />
                        </Col>
                        <Col sm={9}>
                          <div className="mb-2 fw-bold">
                            Do you want to post your job on Naukri?
                          </div>
                          <div className="d-flex gap-1 justify-content-start flex-column">
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="naukri"
                                checked={platforms.naukri === "yes"}
                                onChange={() =>
                                  handleRadioChange("naukri", "yes")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                Yes
                              </label>
                            </div>
                            <div className="form-check">
                              <Input
                                type="radio"
                                name="naukri"
                                checked={platforms.naukri === "no"}
                                onChange={() =>
                                  handleRadioChange("naukri", "no")
                                }
                                disabled={jobData?.post_to_linkedin}
                              />
                              <label className="form-check-label ms-1">
                                No
                              </label>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xxl={8}>
                  <h3 className="text-center">LinkedIn Preview</h3>
                  {platforms.linkedin === "yes" ? (
                   loadingPreview ? (
                          <OrgTableShimmer columns={4} rows={6} titleWidth="220px" /> ) : (
                   <div className="linkedin-ai-preview-wrapper">
                    <div className="d-flex justify-content-between align-items-center mb-2"></div> 
                    {/* Chandu */}
                    <div className={isThisTemplatePosted === true ? "Selected_BgColor p-4 rounded shadow position-relative" : "bg-white p-4 rounded shadow position-relative"} >
                      <div className="py-3">
                        <div className="d-flex justify-content-between mt-3">
                        <Button
                          size="sm"
                          className="blueBtn border-0"
                          color="secondary"
                          onClick={handlePrev}
                        >
                           ◀ Previous
                        </Button>
                        <span className="fw-bold">
                          {activeIndex + 1} / {totalTemplates}
                        </span>
                        <Button
                          size="sm"
                          color="secondary"
                          className="blueBtn border-0"
                          onClick={handleNext}
                        >
                          Next ▶
                        </Button>
                      </div>
                      </div>
                      <div>
                        <div className="d-flex vertical-align-top " style={{height:"50vh",overflow:"auto"}}>
                          <div style={{width:"150px"}}>
                            <input
                              type="radio"
                              name="linkedinTemplate"
                              checked={selectedTemplate === templateEntries[activeIndex]?.[0]}
                              onChange={() => {
                                const [key, previewObj] = templateEntries[activeIndex]
                                handleSelectPreview(key, previewObj)
                              }}
                            />

                          </div>
                          <div>
                            <div>
                              {!isEditing ? (
                              <div
                                  dangerouslySetInnerHTML={{
                                    __html: templateEntries[activeIndex]?.[1]?.html,
                                  }}
                                />

                              ) : (
                                <>
                                  <SunEditor
                                    setContents={editedText}
                                    onChange={setEditedText}
                                    height="250px"
                                    setOptions={{
                                      buttonList: [
                                        ["undo", "redo"],
                                        ["bold", "underline", "italic"],
                                        ["fontSize", "formatBlock"],
                                        ["list", "align"],
                                        ["link"],
                                        ["removeFormat"],
                                      ],
                                    }}
                                  />

                                  <div className="d-flex justify-content-end gap-2 mt-2">
                                    <Button
                                      size="sm"
                                      onClick={handleEditCancel}
                                      className="blueBtn"
                                    >
                                      Cancel
                                    </Button>
                                    <Button
                                      size="sm"
                                      className="blueBtn"
                                      color="primary"
                                      onClick={handleEditSave}
                                    >
                                      Save
                                    </Button>
                                  </div>
                                
                                

                                </>
                                
                              )}
                              


                            
                            </div>
                          </div>

                        </div>
                        <div className="d-flex justify-content-center gap-2 mt-2">
                              {isThisTemplatePosted && (
                                  <>
                                    <Button
                                      size="sm"
                                      color="primary"
                                      className="blueBtn"
                                      disabled
                                    >
                                      Posted
                                    </Button>

                                    <Button
                                  size="sm"
                                  className="blueBtn"
                                  onClick={handleRemoveLinkedInPost}
                                  disabled={isRemoving}
                                >
                                  {isRemoving ? "Removing..." : "Remove Post"}
                                </Button>
                                  </>
                                )}
                                </div>
                      </div>
                      
                      

                      <Button
                        size="sm"
                        color="light"
                        className="position-absolute blueBtn btn btn-primary"
                        style={{ top: 10, right: 10 }}
                        onClick={handleEditOpen}
                      >
                        Edit
                      </Button>
                     
                      {/* <div className="d-flex justify-content-between mt-3">
                        <Button
                          size="sm"
                          className="blueBtn"
                          color="secondary"
                          onClick={handlePrev}
                        >
                          ◀ Previous
                        </Button>
                        <span className="fw-bold">
                          {activeIndex + 1} / {totalTemplates}
                        </span>
                        <Button
                          size="sm"
                          color="secondary"
                          className="blueBtn"
                          onClick={handleNext}
                        >
                          Next ▶
                        </Button>
                      </div> */}
                    </div>
                  </div>)
                ) : (
                  <h5 className="text-center text-muted">
                    LinkedIn not selected
                  </h5>
                  
                )}
                  
              </Col>
            </Row>
          </div>
        </Container>
      </div>
      <Modal
        isOpen={successModal}
        toggle={() => setSuccessModal(false)}
        centered
      >
        <ModalHeader toggle={() => setSuccessModal(false)}>
          Success!
        </ModalHeader>
        <ModalBody>Your job has been posted successfully!</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setSuccessModal(false)}>
            OK
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showLinkedInModal}
        toggle={() => setShowLinkedInModal(false)}
        centered
        size="md"
      >
        <ModalHeader toggle={() => setShowLinkedInModal(false)}>
          Select LinkedIn Organization
        </ModalHeader>
        <ModalBody>
          {linkedInOrgs.length > 0 ? (
            linkedInOrgs.map(org => (
              <div key={org.id} className="form-check mb-2">
                <input
                  type="radio"
                  id={`linkedinOrg_${org.id}`}
                  name="linkedinOrg"
                  checked={selectedLinkedInOrg?.id === org.id}
                  onChange={() => handleLinkedInOrgSelect(org)}
                  className="form-check-input"
                />
                <label
                  className="form-check-label"
                  htmlFor={`linkedinOrg_${org.id}`}
                >
                  {org.organisation_name}
                </label>
              </div>
            ))
          ) : (
            <p>Loading LinkedIn organizations...</p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowLinkedInModal(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => setShowLinkedInModal(false)}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showLinkedInPreview}
        toggle={() => setShowLinkedInPreview(false)}
        size="lg"
        centered
        className="linkedin-preview-modal"
      >
        <ModalHeader toggle={() => setShowLinkedInPreview(false)}>
          LinkedIn AI Post Preview
        </ModalHeader>
        <ModalBody style={{ maxHeight: "70vh", overflowY: "auto" }}>
          <div
            className="p-3 border rounded"
            style={{ background: "#f4f6f8" }}
            dangerouslySetInnerHTML={{
              __html: editablePreviews.linkedin,
            }}
          />
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => setShowLinkedInPreview(false)}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}
export default SocialMediaPost2
